import { useState, useEffect } from "react";
import Select from "react-select";
import { Formik, Form, Field } from "formik";
import { number, object, string, date } from "yup";
import { CaseServices } from "../../../services/CaseServices";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";
import CloseIcon from "../../../assets/hospitalCloseIcon.svg";
import RightArrow from "../../../assets/rightArrowWhite.svg";
import HospitalReferenceDocument from "../hospitalReferenceDocument/HospitalReferenceDocument";
const errorValidation = object({
  days: number().required("Required Field"),
  fromDate: date().required("Required Field"),
  toDate: date().required("Required Field"),
  ward: string().required("Required Field"),
});
const EnhancementFormHospitalPersona = ({
  totalPackageCost,
  setAddEnhancement,
  caseDetails,
  caseId,
  admissionDate,
  currentSubMasterStageId,
  AllCases,
  enhancementList = [],
  caseProcedures = [],
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [latestEnhancement, setLatestEnhancement] = useState(null);
  const [tierCost, setTierCost] = useState([]);
  const [openReferenceModal, setOpenReferenceModal] = useState(false);
  const initialValues = {
    days: "",
    fromDate: "",
    toDate: "",
    ward: "",
    procedureId: "",
  };

  const daysOptions = {
    primary: [
      { value: "1", label: "1" },
      { value: "2", label: "2" },
    ],
    secondary: [
      { value: "1", label: "1" },
      { value: "2", label: "2" },
      { value: "3", label: "3" },
    ],
    tertiary: [
      { value: "1", label: "1" },
      { value: "2", label: "2" },
      { value: "3", label: "3" },
      { value: "4", label: "4" },
      { value: "5", label: "5" },
    ],
  };
  const wardOptions = [
    { value: "ICU with ventilator", label: "ICU with ventilator" },
    { value: "ICU without ventilator", label: "ICU without ventilator" },
    { value: "HDU", label: "HDU" },
    { value: "General Ward", label: "General Ward" },
    { value: "SNCU/NICU", label: "SNCU/NICU" },
  ];
  const handleDaysChange = (item, setFieldValue, values) => {
    setFieldValue("days", item.value);
    if (values.fromDate) {
      const toDate = new Date(values.fromDate);
      toDate.setDate(toDate.getDate() + Number(item.value) - 1);
      setFieldValue("toDate", toDate.toISOString().split("T")[0]);
    }
  };

  const handleDateChange = (e, setFieldValue, values) => {
    const fromDate = e.target.value;
    const toDate = new Date(fromDate);
    toDate.setDate(toDate.getDate() + Number(values.days) - 1);
    setFieldValue("fromDate", fromDate);
    setFieldValue("toDate", toDate.toISOString().split("T")[0]);
  };

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    const data = [
      {
        detailType: "ENHANCEMENT",
        caseId: caseId,
        currentSubMasterStageId: currentSubMasterStageId,
        details: {
          procedureId: values.procedureId,
          enhancementDate: new Date(),
          fromDate: values.fromDate,
          toDate: values.toDate,
          wardType: values.ward,
          enhancementDays: values.days,
          cost: Number(values.price) * Number(values.days),
          enhancementPerDayCost: totalPackageCost,
        },
        status: 1,
        version: 0,
      },
    ];

    try {
      if (Array.isArray(tierCost) && tierCost.length > 0) {
        await CaseServices.addEnhancement(data);
        await AllCases();
        setAddEnhancement(false);
      } else {
        window.alert(
          "The selected procedure does not have any stratifications. Either select a procedure that has stratifications or Request to add new procedure",
        );
      }
    } catch (error) {
      if (error?.response?.status === 420) {
        window.alert(
          "Enhancement documents are not yet mapped. Please perform Initiate Enhancement process when documents are mapped.",
        );
      } else {
        handleApiErrorResponses(error);
      }
    }
    setIsSubmitting(false);
  };
  const handleCaseStageChange = async () => {
    const postStageData = {
      commandCeneterStage: "Request To Add New Enhancement Procedure",
    };
    try {
      const stageResponse = await CaseServices.updateSubMasterStage(
        caseDetails.id,
        postStageData,
      );
      window.alert(stageResponse.data.message);

      await AllCases();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const getLatestCaseStage = async () => {
    try {
      const response = await CaseServices.getLatestCaseStage(caseId);
      if (response?.data?.currnetSubMasterStage[0]) {
        //   setLatestStage(response?.data?.currnetSubMasterStage[0]?.hsaStage);

        setLatestEnhancement(response?.data?.latestEnhancement);
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getProcedureCostList = async (procedureId) => {
    const selectedProcedure =
      caseDetails?.caseprocedures?.find((p) => p.id === procedureId) ||
      caseProcedures.find((p) => p.id === procedureId);
    if (!selectedProcedure) return;
    try {
      const response = await CaseServices.getProcedureCostList(
        selectedProcedure.compositId,
        caseDetails?.patient?.city,
      );
      if (response?.data?.procedureCost?.tierCost) {
        setTierCost(response.data.procedureCost.tierCost);
      } else {
        setTierCost([]);
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    getLatestCaseStage();

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 w-screen h-screen flex justify-center items-center bg-[#017C7180]">
      <div className="relative h-fit w-[50%] bg-white p-[30px] rounded-[30px] overflow-y-auto max-h-[90vh]">
        <div
          className="absolute top-1 right-2 cursor-pointer"
          onClick={() => setAddEnhancement(false)}
        >
          <img src={CloseIcon} alt="close-icon" />
        </div>

        {/* NEW: show existing enhancements if any */}
        {/* {enhancementList.length > 0 &&
          enhancementList.map((enh, idx) => {
            return (
              <div
                key={enh.id || idx}
                className="mb-6 p-4 bg-gray-100 rounded-lg"
              >
                <div className="font-medium mb-2">
                  Enhancement {enhancementList.length - idx}
                </div>
                <div className="text-sm">
                  Days: {enh.details.enhancementDays}
                </div>
                <div className="text-sm">
                  Duration: {enh.details.fromDate} → {enh.details.toDate}
                </div>
                <div className="text-sm">Ward: {enh.details.wardType}</div>
              </div>
            );
          })} */}

        <Formik
          initialValues={initialValues}
          validationSchema={errorValidation}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, setFieldValue, values }) => (
            <Form className="h-[100%]">
              <div className="w-[95%] flex justify-between items-center">
                <div className="text-[40px] font-medium text-black -tracking-[7%]">
                  Enhancement
                </div>
                {caseDetails?.submasterstagestatuses[0]?.commandCenterStage
                  ?.toLowerCase()
                  ?.includes("enhancement approved on tms") && (
                  <button
                    type="button"
                    style={{ border: "1px solid #017C71" }}
                    className="w-fit flex items-center gap-2 bg-[#017C71] text-white rounded-full px-5 py-4 border-0 cursor-pointer uppercase shadow-xl"
                    onClick={() => {
                      if (
                        window.confirm(
                          "Are you aure you want to add a new procedure.",
                        )
                      ) {
                        setOpenReferenceModal(true);
                        handleCaseStageChange();
                      }
                    }}
                  >
                    Add New Procedure
                  </button>
                )}
              </div>
              <div
                style={{ borderTop: "1px solid #969696", marginBlock: "25px" }}
              />
              <div className="h-[75%] flex items-end">
                <div className="h-[100%] w-[75%] overflow-y-auto flex flex-wrap gap-y-10 ">
                  <div className="w-full ">
                    <div className="text-sm text-[#0B0B0B] leading-[21.7px] -tracking-[3%] mb-4">
                      {" "}
                      1. Please Select Procedure
                    </div>

                    <Select
                      name="procedureId"
                      placeholder="Select Procedure"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "100px",
                        }),
                      }}
                      options={
                        caseProcedures.length
                          ? caseProcedures
                          : caseDetails?.caseprocedures
                      }
                      getOptionLabel={(options) => options.procedure}
                      getOptionValue={(options) => options.id}
                      onChange={(item) => {
                        setFieldValue("procedureId", item.id);
                        getProcedureCostList(item.id);
                      }}
                    />
                  </div>
                  <div className="w-full">
                    <div className="text-sm text-[#0B0B0B] leading-[21.7px] -tracking-[3%] mb-4">
                      2. In which ward would you like to take the enhancement?
                    </div>
                    <Select
                      name="ward"
                      placeholder="Select Ward"
                      isDisabled={!tierCost.length}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "100px",
                        }),
                      }}
                      options={tierCost.length ? tierCost : wardOptions}
                      getOptionLabel={(options) =>
                        options.name || options.label
                      }
                      getOptionValue={(options) =>
                        options.price || options.value
                      }
                      onChange={(item) => {
                        setFieldValue("ward", item.name || item.label);
                        setFieldValue("price", item.price || 0);
                        console.log("Ward selected:", item);
                      }}
                    />
                    {!Array.isArray(tierCost) && (
                      <div className="field-error pt-1">
                        * Selected Procedure does not have any stratifications.
                      </div>
                    )}
                    {touched.ward && errors.ward && (
                      <div className="field-error">{errors.ward}</div>
                    )}
                  </div>

                  <div className="w-full ">
                    <div className="text-sm text-[#0B0B0B] leading-[21.7px] -tracking-[3%] mb-4">
                      {" "}
                      3. For how many days would you like to initiate the
                      enhancement?
                    </div>

                    <Select
                      name="days"
                      placeholder="Select Days"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "100px",
                        }),
                      }}
                      options={
                        caseDetails?.hospital?.tmsVersion === "1.0"
                          ? daysOptions.primary
                          : values.ward?.toLowerCase().includes("ventilator")
                            ? daysOptions.secondary
                            : daysOptions.tertiary
                      }
                      onChange={(item) =>
                        handleDaysChange(item, setFieldValue, values)
                      }
                    />
                    {touched.days && errors.days && (
                      <div className="field-error">{errors.days}</div>
                    )}
                  </div>

                  <div className="w-full ">
                    <div className="text-sm text-[#0B0B0B] leading-[21.7px] -tracking-[3%] mb-4">
                      {" "}
                      4. From which date to which date should the enhancement
                      last?
                    </div>
                    <div className="grid grid-cols-2 gap-6 mr-2">
                      <div>
                        <Field
                          type="date"
                          name="fromDate"
                          min={
                            caseDetails?.submasterstagestatuses?.[0]?.commandCenterStage
                              ?.toLowerCase()
                              .includes("enhancement rejected")
                              ? // Enhancement rejected: allow starting again from admissionDate or fromDate
                                (enhancementList?.length > 0
                                  ? new Date(
                                      enhancementList[0]?.details?.fromDate ||
                                        admissionDate,
                                    )
                                  : new Date(
                                      new Date(admissionDate).setDate(
                                        new Date(admissionDate).getDate() + 1,
                                      ),
                                    )
                                )
                                  .toISOString()
                                  .split("T")[0]
                              : // Normal flow: next day after last enhancement
                                (latestEnhancement?.length > 0
                                  ? new Date(
                                      new Date(
                                        latestEnhancement[0]?.details?.toDate,
                                      ).setDate(
                                        new Date(
                                          latestEnhancement[0]?.details?.toDate,
                                        ).getDate() + 1,
                                      ),
                                    )
                                  : new Date(
                                      new Date(admissionDate).setDate(
                                        new Date(admissionDate).getDate() + 1,
                                      ),
                                    )
                                )
                                  .toISOString()
                                  .split("T")[0]
                          }
                          max={new Date().toISOString().split("T")[0]}
                          style={{ border: "1px solid #E4E4E4", width: "100%" }}
                          className="rounded-full py-[10px] px-2"
                          onChange={(e) =>
                            handleDateChange(e, setFieldValue, values)
                          }
                        />
                        {touched.fromDate && errors.fromDate && (
                          <div className="field-error">{errors.fromDate}</div>
                        )}
                      </div>

                      <div>
                        <Field
                          type="date"
                          name="toDate"
                          placeholder="--/--/---"
                          disabled
                          style={{ border: "1px solid #E4E4E4", width: "95%" }}
                          className="rounded-full py-[10px] px-2"
                        />
                        {touched.toDate && errors.toDate && (
                          <div className="field-error">{errors.toDate}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-[30%] flex flex-col items-end">
                  {isSubmitting ? (
                    <CircularProgress />
                  ) : (
                    <button
                      type="submit"
                      style={{ border: "1px solid #017C71" }}
                      className="w-fit flex items-center gap-2 bg-[#017C71] text-white rounded-full mt-3 px-5 py-4 border-0 cursor-pointer uppercase"
                    >
                      SAVE DETAILS <img src={RightArrow} alt="" />
                    </button>
                  )}
                </div>
              </div>
            </Form>
          )}
        </Formik>

        {openReferenceModal && (
          <HospitalReferenceDocument
            setOpen={setAddEnhancement}
            selectedCase={caseDetails}
            AllCases={AllCases}
            type="ENHANCEMENTDOCUMENT"
          />
        )}
      </div>
    </div>
  );
};

export default EnhancementFormHospitalPersona;
